"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types = {
    SupportPortalService: Symbol.for("SupportPortalService"),
    SupportPortalServiceConfig: Symbol.for("SupportPortalServiceConfig"),
    FalconLookupService: Symbol.for("ILookupService"),
    NotificationService: Symbol.for("NotificationService"),
    BaseRequestService: Symbol.for("BaseRequestService"),
    TreeManager: Symbol.for("TreeManager"),
};
exports.Types = Types;
//# sourceMappingURL=Types.js.map